import React from 'react';
import UserRoutes from 'user.routes';

const App = () => {
	return (
		<div>
			<UserRoutes />
		</div>
	);
};
export default App;
